import { Button } from '@pocketlaw/tetris';
import { breakpoint } from '@pocketlaw/tetris/deprecated';
import styled from 'styled-components';
export const StyledButton = styled(Button) `
  @media ${breakpoint.lapAndUp} {
    display: none;
  }
`;
